<template>
  <router-view />
</template>
<script>
  export default {
    name: 'FluxoCaixaContasModule',
  }
</script>
